<template>
    <footer>

        <div class="footer-container">
            <a class="bbe-logo" href="/">
                <img  src="/images/logo-white.png" alt="Byblos Bank Europe">
            </a>
            <footer-nav></footer-nav>
            <language-switcher></language-switcher>
        </div>
                <p>© Byblos Bank Europe NV/SA</p>
                <p>{{ $t('message.footer.disclaimer') }}</p>
    </footer>
</template>

<script>
import SiteButton from "../Components/SiteButton";
import FooterNav from "../Components/Footer/FooterNav";
import LanguageSwitcher from "./LanguageSwitcher";
import {Link} from '@inertiajs/inertia-vue3'

export default {
    name: "SiteFooter",
    components: {LanguageSwitcher, FooterNav, SiteButton,Link}
}
</script>

<style scoped>

</style>
